// extracted by mini-css-extract-plugin
export default {"screen":"LearnigHistoryScreen_screen__MqzrN","list":"LearnigHistoryScreen_list__hWg8H","reviewButton":"LearnigHistoryScreen_reviewButton__QsDgc"};